module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "card",
    attrs: {
      "to": _vm.to
    }
  }, [_c('Badge', [_vm._v(_vm._s(_vm.eventsCount))]), _c('Badge', {
    attrs: {
      "isRightBadge": true
    }
  }, [_vm._v(_vm._s(_vm.professionsCount))]), _c('AppPicture', {
    attrs: {
      "image": _vm.imgStyle,
      "alt": _vm.name
    }
  }), _c('main', {
    staticClass: "card__main"
  }, [_c('AppHeading', {
    attrs: {
      "level": "4",
      "mod": "center, bold, uppercase"
    }
  }, [_vm._v(_vm._s(_vm.name))])], 1), _c('MoreButton', {
    staticClass: "card__btn",
    on: {
      "more": _vm.goToCard
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce9b3ae","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/competences/card/Card.vue
// module id = ff02cd97e64ffdcde08b
// module chunks = 0